import { FormField } from '@direct-frontend/components';
import { type BaseValidationError, type ScrollFieldProps } from '@adv-frontend/form-kit';
import { buildLocation } from '@/shared/lib/buildLocation';
import { useIsInvalidOzonUser, useOzonTriggerProps } from '../../lib';
import { type CourierAddressFieldValue } from '../../model/forms/fieldCourierAddress';
import { type PickupAddressFieldValue } from '../../model/forms/fieldPickupAddress';
import { type OrderFormContext } from '../../model/forms/orderForm';
import { buildErrorMessage } from '../../OrderForm';
import { PickupAddressInput } from '../PickupAddressInput';

interface PickupPointSelectProps {
    context: OrderFormContext;
    isPickupPointDeliveryMethod: boolean;
    fieldAddressPickupValue: PickupAddressFieldValue;
    fieldLocalityValue: string;
    fieldAddressCourierValue: CourierAddressFieldValue;
    setValue: (value: PickupAddressFieldValue) => void;
    errors: BaseValidationError[];
    scrollProps?: ScrollFieldProps;
    openRegistrationOzon: VoidFunction;
}

export const PickupPointSelect = (props: PickupPointSelectProps) => {
    const {
        context,
        isPickupPointDeliveryMethod,
        fieldAddressPickupValue,
        fieldAddressCourierValue,
        fieldLocalityValue,
        setValue,
        errors,
        scrollProps,
        openRegistrationOzon,
    } = props;

    const { order, storeSlug } = context;

    const isInvalidOzonUser = useIsInvalidOzonUser({ type: 'pickup' });
    const { caption } = useOzonTriggerProps({ isShow: isInvalidOzonUser, openRegistrationOzon });

    if (!isPickupPointDeliveryMethod) {
        return null;
    }

    return (
        <FormField size="s" errorMessage={buildErrorMessage(errors)} {...scrollProps}>
            {(fieldProps) => (
                <PickupAddressInput
                    {...fieldProps}
                    caption={caption}
                    placeholder="Пункт выдачи"
                    order={order}
                    storeSlug={storeSlug}
                    value={fieldAddressPickupValue}
                    onChange={setValue}
                    locality={fieldLocalityValue}
                    defaultLocation={
                        buildLocation(fieldAddressPickupValue) ||
                        buildLocation(fieldAddressCourierValue) ||
                        fieldLocalityValue
                    }
                    size="m"
                    validationState={buildErrorMessage(errors) ? 'invalid' : 'valid'}
                />
            )}
        </FormField>
    );
};
